import { ComputedCheckboxInput } from '@framework/form';
import React from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { ParagraphSizeText } from '../../common/style/ParagraphSizeText';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { IComputedBooleanWidget } from '../IComputedWidget';
import { useBooleanExpressionValue } from './useBooleanExpressionValue';

export interface IComputedBooleanWidgetComponentProps
  extends IWidgetComponentProps<IComputedBooleanWidget> {}

export function ComputedBooleanWidgetComponent(
  props: IComputedBooleanWidgetComponentProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const checked = useBooleanExpressionValue(options.name, widget.expression);

  return (
    <ConfigFormItem
      hidden={widget.layout?.hide}
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options?.helpText} />}
      layout={{
        hideVisualLabel: options?.hideLabel,
        removeLabelSpace: props.widget.layout?.isTableColumn,
      }}
      readonly={options.readonly}
    >
      <ComputedCheckboxInput
        name={options.name}
        tabIndex={options.preview ? -1 : undefined}
        checked={checked}
        readOnly={props.readonly}
      >
        <ParagraphSizeText>
          <RichTextAdvancedRender hasCustomFont inline text={options.text} />
        </ParagraphSizeText>
      </ComputedCheckboxInput>
    </ConfigFormItem>
  );
}
